export function lightOrDark(color) {
  // Check the format of the color, HEX or RGB?
  var r = '';
  var g = '';
  var b = '';
  if (color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

    r = color >> 16;
    g = (color >> 8) & 255;
    b = color & 255;
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 127.5) {
    return 'light';
  } else {
    return 'dark';
  }
}

export function validateEmail(emailFieldId, confirmEmailFieldId) {
  const emailField = $(`#${emailFieldId}`);
  const confirmEmailField = $(`#${confirmEmailFieldId}`);
  if (emailField[0].value !== confirmEmailField[0].value) {
    emailField.addClass('is-invalid');
    emailField.removeClass('is-valid');
    confirmEmailField.addClass('is-invalid');
    confirmEmailField.removeClass('is-valid');
    return false
  } else {
    emailField.addClass('is-valid');
    emailField.removeClass('is-invalid');
    confirmEmailField.addClass('is-valid');
    confirmEmailField.removeClass('is-invalid');
    return true
  }
}

export function checkEmailConfirmation() {
  var validity = true
  let email_submit_confirmation = document.getElementsByClassName('email-field-input');
  let email_list = []
  if (email_submit_confirmation) {
    for (var i = 0; i < email_submit_confirmation.length; i++) {
      var id = email_submit_confirmation[i].id.split('-').slice(-1)[0]
      validity = validateEmail(`email-${id}`,`email-confirmation-${id}`)
      if (email_list.includes($(`#email-${id}`)[0].value)) { 
        validity = false
        $(`#email-${id}`).addClass('is-invalid');
        $(`#email-${id}`).removeClass('is-valid');
      }
      if (validity === false) {
        break;
      }
      email_list.push($(`#email-${id}`)[0].value)
    }
  }
  return validity
}